module.exports = __webpack_public_path__ + "static/media/caret-arrow-up.0885e767.svg";